import { render, staticRenderFns } from "./SettingExactBasic.vue?vue&type=template&id=d255c2f2&scoped=true"
import script from "./SettingExactBasic.vue?vue&type=script&lang=js"
export * from "./SettingExactBasic.vue?vue&type=script&lang=js"
import style0 from "./SettingExactBasic.vue?vue&type=style&index=0&id=d255c2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d255c2f2",
  null
  
)

export default component.exports